import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=34a6c4b9&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34a6c4b9')) {
      api.createRecord('34a6c4b9', component.options)
    } else {
      api.reload('34a6c4b9', component.options)
    }
    module.hot.accept("./customer.vue?vue&type=template&id=34a6c4b9&", function () {
      api.rerender('34a6c4b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/example/customer/customer.vue"
export default component.exports